import {testIdProps} from '@github-ui/test-id-props'
import {Box, Label} from '@primer/react'

import type {IssueType} from '../../../api/common-contracts'
import {ItemType} from '../../../api/memex-items/item-type'
import {type ColumnValue, hasValue, isLoading} from '../../../models/column-value'
import type {MemexItemModel} from '../../../models/memex-item-model'
import {TextPlaceholder} from '../../common/placeholders'
import {BaseCell} from '../cells/base-cell'
import {DropdownCell} from '../cells/dropdown-cell'
import {useRecordCellRenderer} from '../performance-measurements'
import {withCellRenderer} from './cell-renderer'

type Props = Readonly<{
  currentValue: ColumnValue<IssueType>
  model: MemexItemModel
  dropdownRef?: React.MutableRefObject<HTMLButtonElement | null>
  isDisabled?: boolean
}>

export const LoadingIssueTypeCell = () => (
  <BaseCell>
    <TextPlaceholder minWidth={50} maxWidth={100} {...testIdProps('placeholder')} />
  </BaseCell>
)

export const IssueTypeRenderer = withCellRenderer<Props>(function IssueTypeRenderer({
  currentValue,
  model,
  dropdownRef,
  isDisabled,
}) {
  useRecordCellRenderer('IssueTypeRenderer', model.id)

  if (isLoading(currentValue)) {
    return <LoadingIssueTypeCell />
  }

  if (model.contentType === ItemType.DraftIssue) {
    return <DropdownCell ref={dropdownRef} isDisabled={isDisabled} />
  }

  const columnValue = hasValue(currentValue) ? currentValue.value : undefined

  return (
    <DropdownCell ref={dropdownRef} isDisabled={isDisabled}>
      {columnValue && (
        <Box sx={{overflow: 'hidden', display: 'flex'}}>
          <Label sx={{bg: 'canvas.subtle', color: 'fg.muted', my: 0}}>{columnValue.name}</Label>
        </Box>
      )}
    </DropdownCell>
  )
})

IssueTypeRenderer.displayName = 'IssueTypeRenderer'

try{ LoadingIssueTypeCell.displayName ||= 'LoadingIssueTypeCell' } catch {}